import React, { useContext } from 'react';
import { Box, Stack, Typography, Link } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { UserStateContext } from 'context/user-state-context';

/**
 * Impersonation banner content. Positioning + layout shift live in the parent
 * `<TopBanner>` shell — this component just renders its yellow strip when active
 * and stretches to fill whatever slot the shell gives it.
 */
export const ImpersonationBanner = () => {
  const {
    impersonatingAsCustomer,
    setImpersonatingAsCustomer,
    asCompany
  } = useContext(UserStateContext);
  if (!impersonatingAsCustomer) return null;
  return <Box sx={{
    flex: 1,
    backgroundColor: '#F5A623',
    color: '#1D252D',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{
      px: 1.5,
      py: 0.5
    }}>
        <VisibilityIcon sx={{
        fontSize: 14,
        flexShrink: 0
      }} />
        <Typography sx={{
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.3
      }}>
          Viewing as a PLG user would see {asCompany?.name || 'this account'} — superuser-only screens are hidden.
        </Typography>
        <Link component="button" onClick={() => setImpersonatingAsCustomer(false)} sx={{
        'fontSize': 12,
        'fontWeight': 600,
        'color': '#1D252D',
        'textDecorationColor': '#1D252D',
        'lineHeight': 1,
        ':hover': {
          color: '#1D252D'
        }
      }}>
          Exit
        </Link>
      </Stack>
    </Box>;
};